import { render, staticRenderFns } from "./SettingsSanitizeFilenames.vue?vue&type=template&id=bd5a10be&scoped=true"
import script from "./SettingsSanitizeFilenames.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettingsSanitizeFilenames.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SettingsSanitizeFilenames.vue?vue&type=style&index=0&id=bd5a10be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd5a10be",
  null
  
)

export default component.exports